import React from "react";
import { Document, Page, View, StyleSheet, Font } from "@react-pdf/renderer";
import FirstPageContent from "./FirstPage/first-page";
import DateUtils from "src/services/utils/DateUtils";
import FirstHeader from "./FirstPage/firstHeader";
import FirstFooter from "./FirstPage/firstFooter";
import PageContent from "./OtherPages/page-content";
import Header from "./OtherPages/header";
import {
    FONT_OPEN_SANS_BOLD,
    FONT_OPEN_SANS_REGULAR,
  } from "src/components/constants";

Font.register({
    family: "Open Sans",
    fonts: [
        {
            src: FONT_OPEN_SANS_REGULAR,
            fontWeight: 400,
            fontStyle: "normal",
        },
        {
            src: FONT_OPEN_SANS_BOLD,
            fontWeight: 600,
            fontStyle: "bold",
        }
    ]
});

// Fixed header height (56) + breathing room. Applied only on content pages
// so wrapped pages do not render under the repeating header.
const CONTENT_HEADER_HEIGHT = 56;
const CONTENT_HEADER_GAP = 16;
const FOOTER_HEIGHT = 27;
const FOOTER_GAP = 12;

const styles = StyleSheet.create({
  firstPage: {
    fontFamily: "Open Sans",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    paddingBottom: FOOTER_HEIGHT + FOOTER_GAP,
  },
  contentPage: {
    fontFamily: "Open Sans",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    paddingTop: CONTENT_HEADER_HEIGHT + CONTENT_HEADER_GAP,
    paddingBottom: FOOTER_HEIGHT + FOOTER_GAP,
  },
  content: {
    flexGrow: 1,
  },
});

const PdfDocument = (props) => {
  const { data, organization, selecetdCountry } = props;
  const { primaryLogo, secondaryLogo, name, city } = organization;
  const primaryColor = organization?.primaryColor || "#5664d2";
  
  const dateUtils = new DateUtils();

    const logo = {};
    
    if (secondaryLogo) {
        logo.src = secondaryLogo;
        logo.size = {
            maxWidth: '200px',
            height: `${organization.secondaryLogoSize || 40}px`
        }
    }
    else {
        logo.src = primaryLogo;
        logo.size = {
            maxWidth: '240px',
            maxHeight: '120px',
            height: `${organization.primaryLogoSize || 40}px`
        }
    }
  
  
  const generateColor = (hexColor, magnitude) => {
        hexColor = hexColor.replace(`#`, ``);
        if (hexColor?.length === 6) {
            const decimalColor = parseInt(hexColor, 16);
            let r = (decimalColor >> 16) + magnitude;
            r > 255 && (r = 255);
            r < 0 && (r = 0);
            let g = (decimalColor & 0x0000ff) + magnitude;
            g > 255 && (g = 255);
            g < 0 && (g = 0);
            let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
            b > 255 && (b = 255);
            b < 0 && (b = 0);
            return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
        } else {
            return hexColor;
        }
    };

    
  const startColor = primaryColor;
  const stopColor = generateColor(primaryColor, 15);
  return (
    <Document>
      <Page size="A4" style={styles.firstPage}>
        <FirstHeader 
            startColor={startColor} 
            stopColor={stopColor} 
            backgroundColor={primaryColor} 
            logo={logo} 
        />
        <View style={styles.content}>
          <FirstPageContent
            name={name}
            country={selecetdCountry}
            city={city}
            downloadedAt={dateUtils.convertTimestampToOnlyDate(dateUtils.getCurrentDateInTimestamp())}
            created={dateUtils.convertTimestampToOnlyDate(data.created_at)}
            updated={data.updated_at ? dateUtils.convertTimestampToOnlyDate(data.updated_at) : null}
          />
        </View>
        <FirstFooter backgroundColor={primaryColor} />
      </Page>

      <Page size="A4" style={styles.contentPage} wrap>
        <Header 
            startColor={startColor} 
            stopColor={stopColor} 
            backgroundColor={primaryColor} 
            logo={logo} 
        />
        <PageContent
          sections={data?.sections || []}
          sub_contractors={data?.sub_contractors || []}
        />
        <FirstFooter backgroundColor={primaryColor} />
      </Page>
    </Document>
  );
};

export default PdfDocument;
